import { CheckCircle, Headphones, Phone, Settings } from "lucide-react";
import { StepIndicator } from "./step-indicator";
import React from "react";

export const ProgressBar: React.FC<{ currentStep: number }> = ({ currentStep }) => {
  const steps = [
    { icon: <Phone className="w-6 h-6" />, label: "Get Phone Number" },
    { icon: <Settings className="w-6 h-6" />, label: "Configure Settings" },
    { icon: <Headphones className="w-6 h-6" />, label: "Test Connection" },
    { icon: <CheckCircle className="w-6 h-6" />, label: "Complete Setup" },
  ];

  return (
    <div className="flex items-center justify-between max-w-2xl mx-auto mb-12">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <StepIndicator
            isActive={currentStep === index}
            isCompleted={currentStep > index}
            icon={step.icon}
            label={step.label}
          />
          {index < steps.length - 1 && (
            <div
              className={`flex-1 h-0.5 mx-4 ${
                currentStep > index ? "bg-blue-600" : "bg-gray-300"
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};